import { render, staticRenderFns } from "./TermsOfBusiness.vue?vue&type=template&id=606ed403&scoped=true&"
import script from "./TermsOfBusiness.vue?vue&type=script&lang=js&"
export * from "./TermsOfBusiness.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfBusiness.vue?vue&type=style&index=0&id=606ed403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ed403",
  null
  
)

export default component.exports